var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-quoteblock__wrapper" }, [
    _c("div", { staticClass: "c-quoteblock__inner" }, [
      _vm.displayIcon
        ? _c(
            "div",
            { staticClass: "c-quoteblock__inner--icon" },
            [_c("v-icon", { attrs: { name: _vm.icon, size: "lg" } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "c-quoteblock__inner--quote" }, [
        _c("div", { staticClass: "c-quoteblock__quote" }, [
          _vm._v(_vm._s(_vm.quote))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "c-quoteblock__quoteby" }, [
          _vm._v(_vm._s(_vm.quoteBy))
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }